import API from "./axios";

// Get all chat rooms for the current user
export const getChatRooms = async () => {
    try {
        const response = await API.get('/chat/rooms');
        return response.data;
    } catch (error) {
        throw (error.response?.data?.message) || 'Failed to fetch chat rooms';
    }
};

export const getChatMessages = async (roomId) => {
    try {
        const response = await API.get(`/chat/rooms/${roomId}/messages`);
        return response.data;
    } catch (error) {
        throw (error.response?.data?.message) || 'Failed to fetch messages';
    }
};

export const sendChatMessage = async (roomId, message) => {
    try {
        const response = await API.post(`/chat/rooms/${roomId}/messages`, { message });
        return response.data;
    } catch (error) {
        throw (error.response?.data?.message) || 'Failed to send message';
    }
};
